<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <div
      class="position-relative"
      style="max-width: 1900px; margin-left: auto; margin-right: auto"
    >
      <b-container>
        <b-row>
          <b-col>
            <h1>Convince your boss</h1>
            <h2>
              GET A YES! AND JOIN 1200+ DEVELOPERS AT ØREDEV!
            </h2>
            <p>
              Here are some useful arguments to convince your manager of the
              benefits of your participation at Øredev. Maybe they need a little
              nudge or two to assure them that this is a good investment? Let
              your boss know what's in it both for your current and future
              customers!
            </p>
            <p>
              In today's world where knowledge is power, it should come as no
              surprise that the most valuable asset for any company is the
              knowledge of its employees. And within our current knowledge-based
              economy, competent and confident employees are the foundation for
              a successful business.
            </p>
            <ul>
              <li>
                Meet the greatest minds in the industry all in one place, and
                discuss issues from your daily work with experts
              </li>
              <li>
                Discover and learn about the next generation of tools and
                methods in your field
              </li>
              <li>
                Connect with your peers and exchange experiences - Øredev is a
                great place to mingle and make new contacts
              </li>
              <li>
                Broaden your knowledge - Øredev covers the whole software
                development cycle
              </li>
              <li>
                Bring back knowledge and new insights back your team, using the
                videos to explain the key takeaways - all Øredev talks are
                recorded and released for you to share.
              </li>
              <li>Get inspired!</li>
            </ul>

            <DividerPink />

            <h2>Our best tip: Put it in writing!</h2>
            <p>
              Take the time to analyze Øredev on paper, give it to your boss,
              then follow up with a verbal request, your boss will know you mean
              business.<br />
              Sure, it takes time. But attending conferences is vital for your
              personal development in addition to gaining opportunities to
              improve your company's operations.
            </p>
            <p>
              We have also created
              <a
                href="https://drive.google.com/file/d/1Gih1ahVp3oatUOaiQticCynbK1g00mBs/view"
                target="_blank"
                rel="noopener noreferrer"
                >an info pack</a
              >
              that you can include to convince your boss to say YES to Øredev.
            </p>
            <p>Here is a sample letter that you could be inspired by:</p>
            <p>
              <b>Dear *Approving Manager*,</b>
            </p>
            <p>
              I am writing to request your approval to attend the Øredev
              Conference, taking place 5-7 November 2025 in Malmö, Sweden. This
              valuable event offers a comprehensive educational program,
              including sessions on topics directly related to our current and
              future business.<br />
              By attending this event I expect to learn how to *implement the
              latest trends* and *emerging technologies*.
            </p>
            <p>
              There will be 1200+ developers, managers, and executives from
              around the world attending this event. Several activities are
              scheduled where I will be able to network and learn more about how
              other companies *tackle technical challenges*.<br />
              I plan to return with valuable recommendations and best practices
              for improving our *project* and *team*.
            </p>
            <p>
              I look forward to participating in the following sessions, among
              others:
            </p>

            <p style="overflow: hidden">
              Session Title __________________________________________
              <br />
              Session Title __________________________________________
              <br />
              Session Title __________________________________________
              <br />
              <br />
            </p>
            <p>
              The conference fee for the regular ticket is 14,900 SEK - this
              includes 3 packed days of talks, exhibit hall entry, breakfast and
              lunch each day and dinner one evening. If we decide early there are
              better prices available, and group discounts.
            </p>
            <p>
              I would appreciate your approval as soon as possible in order to
              maximize both conference and travel discounts.
            </p>
            <p>
              Sincerely,<br />
              [Name]<br />
              [Title]
            </p>
            <p class="m-0"><b>Good luck! We hope to see you in November!</b></p>

            <DividerBlue />
          </b-col>
        </b-row>
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute d-none d-xl-block"
        style="top: 17%; right: 3%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute d-none d-xl-block"
        style="top: 32%; left: 2%; max-width: 14%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 15%; right: 2%; max-width: 10%"
        alt=""
        aria-hidden="true"
      />
    </div>
    <!-- Mobile Bottom Images -->
    <b-container
      fluid
      class="position-relative d-sm-none"
      style="height: 195vw; overflow: hidden"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_12.png"
        class="position-absolute"
        style="width: 90vw; left: -8vw; bottom: 104vw"
        alt="A delegate pointing out something interesting to 3 colleagues."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_13.png"
        class="position-absolute"
        style="width: 95vw; right: -14vw; bottom: 5vw"
        alt="The host at Øredev throwing confetti into the air from the stage."
      />
    </b-container>
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 16vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_12.png"
        class="position-absolute"
        style="width: 23vw; left: 5vw; bottom: -6vw"
        alt="A delegate pointing out something interesting to 3 colleagues."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156661/2025/Footer_pages/img_13.png"
        class="position-absolute"
        style="width: 23vw; left: 36vw; bottom: -8vw"
        alt="The host at Øredev throwing confetti into the air from the stage."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_14.png"
        class="position-absolute"
        style="width: 23vw; left: 64vw; bottom: -3vw"
        alt="A speaker gesturing towards code on the screen behind her."
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "ConvinceBoss",
  data() {
    return {
      doctitle: "Convince you boss - " + this.$store.state.conferencename,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ConvinceBoss.vue